import PropTypes from 'prop-types';
import { DrawerEntityCard } from '@aimsos/ui';

import { LayoutDashboard } from 'lucide-react';

/**
 * Dashboard placements list for `WidgetDetailPanel` (CT-5188 / DS-4).
 *
 * Extracted to its own file (CT-5183 review — one component per file).
 * Stateless, so a plain function per convention.
 */
function PlacementList({ dashboards, emptyLabel, fallbackLabel }) {
  if (!dashboards.length) {
    return <p className="m-0 text-xs text-content-muted">{emptyLabel}</p>;
  }
  return (
    <div className="flex min-w-0 flex-col gap-2">
      {dashboards.map((dashboard, index) => (
        <DrawerEntityCard
          key={dashboard.id || `${dashboard.name}-${index}`}
          // `label` is the small caps slot and `value` the prominent one, so the
          // dashboard's name goes in `value` and what it is scoped to in `label`.
          label={dashboard.entity || fallbackLabel}
          value={dashboard.name}
          icon={LayoutDashboard}
          variant="neutral"
          size="sm"
        />
      ))}
    </div>
  );
}

PlacementList.propTypes = {
  dashboards: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      entity: PropTypes.string,
    }),
  ).isRequired,
  emptyLabel: PropTypes.string.isRequired,
  fallbackLabel: PropTypes.string.isRequired,
};

export default PlacementList;
